import AppEvents from 'Shared/app-events';
import ds from 'Shared/ds';
import Modal from 'Shared/modal';
import { StaticCache } from 'Shared/cache';

export default class ProductApi {
    static productItemCache = new StaticCache("productItem");
    static variantItemCache = new StaticCache("variantItem");

    static sendMessage = (data) => Modal.load(this.#const.USERMESSAGE_URL, data);

    static editCArticleId = sku => Modal
        .load(this.#const.CUSTOMERARTICLEID_EDIT, {
            sku: sku
        })
        .then(() => AppEvents.emit(this.Events.CUSTOMERARTICLEID_CHANGED));

    static findVariantByAttribute = (productId, currentVariantId, optionId) => ds.get(this.#const.FIND_VARIANT_BY_ATTRIBUTE, { productId, currentVariantId, optionId });

    static productData = (productId, variantId, orderUnitId) => ds.get(`/catalog/product/${productId}/json`, { va: variantId, u: orderUnitId });

    static orderTable = (productId) => ds.get(`/catalog/product/${productId}/ordertable`);

    static productInfo = (productId, variantId) => this.productItemCache.getOrAddAsync(`${productId};${variantId}`, () => ds.get(this.#const.PRODUCT_INFO + productId, { variantId }));

    static quickInfo = (data = {}) => {
        const query = new URLSearchParams();

        Object.keys(data).forEach(key => {
            if (key !== 'refTypes' && key !== 'pictureTypeIds' && data[key] != null) {
                query.append(key, data[key]);
            }
        });

        data.refTypes?.forEach(r => query.append('refTypes', r));
        data.pictureTypeIds?.forEach(p => query.append('pictureTypeIds', p));

        const queryString = query.toString();

        return ds.get(`/catalog/product/${data.id}/quickinfo?${queryString}`);
    }

    static relatedVariants = (data) => ds.get(`/catalog/relatedvariants`, data);

    static stockList = (variantId, productUnitId) => ds.get(`/catalog/stocklist`, { variantId, productUnitId });


    static variant = (productId, variantId, data = {}) => {
        data.ProductId = productId;
        data.variantId = variantId;

        return ds.get(this.#const.VARIANT, data); //await this.variantItemCache.getOrAddAsync(`${productId}, ${variantId}`, () => ds.get(this.#const.VARIANT, { productId, variantId }));
    }

    static cachedVariant = (productId, variantId) => this.variantItemCache.get(`${productId}, ${variantId}`);

    static #const = {
        FIND_VARIANT_BY_ATTRIBUTE: "/catalog/product/findvariant",
        CUSTOMERARTICLEID_EDIT: "/nvcustomerarticle/modal/edit",
        USERMESSAGE_URL: "/catalog/usermessage/usermessagemodal",
        PRODUCT_INFO: "/catalog/productinfo/",
        VARIANT: "/catalog/variant"
    };

    static Events = {
        CUSTOMERARTICLEID_CHANGED: "carticleid-changed",
        SHOW_VARIANT: "show-variant",
        UNIT_CHANGED: "unit-changed"
    };
}